module.exports = __webpack_public_path__ + "media/images/reviews/trust_pilot_on_dark-44f48ac3c8544f117f91d756656ff263.svg";